import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { KnBrCartQuoteSummaryComponent } from './kn-br-cart-quote-summary.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ParentKnBrCounterComponent: {
                // component: KnBrCartQuoteSummaryComponent,
                },
            },
        } as CmsConfig),
        KnBrCartQuoteSummaryComponent,
    ],
    exports: [KnBrCartQuoteSummaryComponent],
})
export class KnBrCartQuoteSummaryModule { }
